import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Customs: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M106.37 32.3954L104.198 35.3815C104.198 35.3815 94.7192 38.7657 92.1521 43.9416C92.1521 43.9416 88.9925 47.5249 92.1521 79.1772L139.743 80.3716L135.991 43.9416C135.991 43.9416 134.807 34.1871 128.685 32.7936C128.685 32.7936 121.971 31.7982 117.626 31.002L106.37 32.3954Z"
      fill="#28211E"
    />
    <path
      d="M120.193 31.5991L128.29 32.7935C129.628 33.0152 130.883 33.5935 131.924 34.4685C132.966 35.3436 133.757 36.4836 134.214 37.7703C134.214 37.7703 136.386 41.5527 136.584 49.9137L135.596 50.3118C135.596 50.3118 134.214 39.3629 130.067 37.1731C126.746 35.8021 123.309 34.7361 119.798 33.988L120.193 31.5991Z"
      fill="#3A3A3A"
    />
    <path
      d="M120.193 31.5991C120.193 31.9973 117.034 54.2932 113.874 67.631L118.811 66.6357C121.196 55.216 122.779 43.6412 123.551 31.9973L120.193 31.5991Z"
      fill="#C9CAC9"
    />
    <path
      d="M123.55 34.9834C123.55 33.9881 123.748 32.9927 123.748 31.9974L120.193 31.4001C120.193 31.4001 119.996 32.3955 119.798 33.9881"
      fill="#E5E5E5"
    />
    <path d="M106.173 29.2102V32.3953L115.257 39.1638L118.416 31.2009L106.173 29.2102Z" fill="#DEA07B" />
    <path
      d="M91.5597 73.6033L96.4965 72.6079C95.8591 70.3246 95.397 67.9952 95.1142 65.6404C94.8479 63.1278 94.716 60.6026 94.7193 58.0757C94.7193 58.0757 94.9167 49.7147 96.694 46.1314C98.4713 42.5482 106.963 37.7704 106.963 37.7704L104.001 35.3816C101.153 36.5436 98.4388 38.0119 95.9041 39.7612C94.5857 40.6125 93.4748 41.7528 92.6542 43.097C91.8336 44.4412 91.3245 45.9548 91.1647 47.5249C90.349 56.2061 90.4814 64.9513 91.5597 73.6033Z"
      fill="#3A3A3A"
    />
    <path d="M106.173 32.3953L115.257 39.1637L112.887 42.747L104 35.3813L106.173 32.3953Z" fill="#3A3A3A" />
    <path d="M101.433 51.5061L101.631 71.8114L103.803 71.4132" fill="black" />
    <path d="M127.698 44.9368L131.844 66.4365L130.067 66.6355" fill="black" />
    <path d="M118.416 31.2009L115.257 39.1638L119.404 41.3536L120.193 31.5991L118.416 31.2009Z" fill="#3A3A3A" />
    <path
      d="M124.34 18.4605C124.735 25.8262 120.786 32.1964 114.269 32.5946C107.752 32.9927 102.223 26.6225 101.631 19.2568C101.038 11.8912 103.013 5.71997 111.702 5.71997C120.391 5.71997 123.945 10.8958 124.34 18.4605Z"
      fill="#F1BE96"
    />
    <path
      d="M108.74 17.2661C107.16 17.067 108.345 22.442 107.358 23.0392C106.37 23.6364 105.975 19.655 104.395 19.655C102.026 19.655 102.421 25.6271 101.631 19.2568C100.643 11.8912 103.013 5.71997 111.702 5.71997C117.429 5.71997 120.983 8.10883 122.761 12.0903C123.018 12.6189 123.149 13.2011 123.143 13.7901C123.136 14.3791 122.993 14.9583 122.724 15.4812C122.455 16.0041 122.068 16.456 121.594 16.8006C121.121 17.1452 120.573 17.3728 119.996 17.4652C116.263 18.0878 112.449 18.0204 108.74 17.2661Z"
      fill="#996A0D"
    />
    <path
      opacity="0.5"
      d="M97.0889 167.166L118.219 163.384L83.4632 146.065L62.3334 149.847L97.0889 167.166Z"
      fill="url(#customs_paint0_linear)"
    />
    <path d="M117.626 97.89L190.099 84.7513L148.827 64.0479L76.354 77.1865L117.626 97.89Z" fill="#FDDE84" />
    <path d="M118.219 98.288V163.384L83.4631 146.065V80.7698L118.219 98.288Z" fill="#C39000" />
    <path d="M118.219 98.2881V163.384L179.238 152.436V87.1401L118.219 98.2881Z" fill="#FCCE09" />
    <path d="M117.034 96.4964L192.667 82.7604L149.617 61.2607L73.7869 74.7976L117.034 96.4964Z" fill="#996A0D" />
    <path d="M117.034 96.4964V100.677L73.7869 78.9781V74.7976L117.034 96.4964Z" fill="#634509" />
    <path d="M117.034 96.4962V100.677L192.667 86.9407V82.7603L117.034 96.4962Z" fill="#BC9361" />
    <path
      opacity="0.5"
      d="M141.521 82.3623L150.407 80.7697L135.597 73.4041L126.513 74.9966L141.521 82.3623Z"
      fill="url(#customs_paint1_linear)"
    />
    <path d="M150.407 57.0803L176.474 52.5016L161.466 45.136L135.399 49.7146L150.407 57.0803Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M143.89 53.8951L169.957 49.3165L167.587 48.1221L141.521 52.7007L143.89 53.8951Z"
      fill="#AA7B33"
    />
    <path d="M150.407 57.0802V80.7697L135.399 73.4041V49.7146L150.407 57.0802Z" fill="#C39000" />
    <path opacity="0.4" d="M143.89 53.8951V59.071L141.521 57.8765V52.7007L143.89 53.8951Z" fill="#AA7B33" />
    <path d="M150.407 57.0801V80.7696L176.474 75.9919V52.5015L150.407 57.0801Z" fill="#FCCE09" />
    <path d="M119.009 22.8398L119.996 26.4231L118.416 26.2241" fill="#DEA07B" />
    <path d="M161.466 68.8254V75.3948L172.919 73.4041V66.8347L161.466 68.8254Z" fill="white" />
    <path
      d="M168.18 73.006C168.772 72.807 169.562 72.807 170.155 72.6079V68.6265C169.562 68.8255 168.772 68.8255 168.18 69.0246V73.006Z"
      fill="black"
    />
    <path
      d="M162.651 74.0014C163.243 73.8023 163.835 73.8023 164.428 73.6032V69.6218C163.835 69.8209 163.243 69.8209 162.651 70.02V74.0014Z"
      fill="black"
    />
    <path
      d="M166.205 73.4042C166.483 73.434 166.763 73.3635 166.995 73.2052V69.2237C166.717 69.1939 166.437 69.2644 166.205 69.4228V73.4042Z"
      fill="black"
    />
    <path
      d="M171.932 68.4273C171.653 68.3975 171.374 68.4681 171.142 68.6264V72.6078C171.339 72.6078 171.734 72.4088 171.932 72.4088V68.4273Z"
      fill="black"
    />
    <path d="M165.218 73.404H165.613V69.4226H165.218V73.404Z" fill="black" />
    <path
      opacity="0.5"
      d="M106.173 92.9131L118.219 91.1214L111.9 84.7512L105.185 80.3716L87.0177 83.3577L106.173 92.9131Z"
      fill="url(#customs_paint2_linear)"
    />
    <path d="M106.173 84.7511L121.971 80.9687L116.836 74.9966L100.643 79.1771L106.173 84.7511Z" fill="#E5E5E5" />
    <path d="M107.753 83.3576L117.231 80.7696L117.034 80.5706L107.555 83.1585L107.753 83.3576Z" fill="#8E8E8E" />
    <path d="M118.219 91.1213L133.819 86.7418L127.895 80.5706L111.899 84.7511L118.219 91.1213Z" fill="#EFEFEF" />
    <path d="M115.059 85.3483L123.156 82.9595L114.862 85.1493L115.059 85.3483Z" fill="#8E8E8E" />
    <path d="M115.849 86.1448L125.92 83.3578L125.723 83.1587L115.651 85.9457L115.849 86.1448Z" fill="#8E8E8E" />
    <path d="M117.231 87.5381L122.366 85.9456H122.168L117.034 87.3391L117.231 87.5381Z" fill="#8E8E8E" />
    <path d="M111.899 84.7511L128.092 80.5706L121.773 80.9687L105.975 84.7511H111.899Z" fill="#C9CAC9" />
    <path d="M111.307 84.1541L122.168 81.5662H121.576L110.912 84.3532L111.307 84.1541Z" fill="#8E8E8E" />
    <path d="M106.173 81.1678L106.765 80.9688L106.173 81.1678Z" fill="black" />
    <path d="M105.975 80.9688L106.765 80.7698L105.975 80.9688Z" fill="black" />
    <path d="M106.173 81.1678L106.963 80.9688V81.1678L106.37 81.3669L106.173 81.1678Z" fill="black" />
    <path d="M111.307 79.7744L110.715 79.9735L111.307 79.7744Z" fill="black" />
    <path d="M111.504 79.9734L110.715 80.1725L111.504 79.9734Z" fill="black" />
    <path d="M110.517 79.7745L111.11 79.5754V79.7745H110.517Z" fill="black" />
    <path
      d="M106.963 81.168L106.568 80.3717C106.568 80.3717 106.963 80.3717 106.963 80.1726H107.16C107.16 80.1987 107.165 80.2246 107.175 80.2488C107.185 80.2729 107.2 80.2949 107.218 80.3134C107.236 80.3319 107.258 80.3465 107.282 80.3565C107.306 80.3665 107.332 80.3717 107.358 80.3717H107.555L108.147 80.1726C108.147 80.1726 108.345 80.5707 108.147 80.5707C107.777 80.8165 107.38 81.017 106.963 81.168Z"
      fill="black"
    />
    <path d="M108.542 80.3716L108.74 80.5707L108.345 80.7697L107.95 80.3716H108.542Z" fill="black" />
    <path d="M109.135 80.1726L109.332 80.5707L108.937 80.7698L108.74 80.3717L109.135 80.1726Z" fill="black" />
    <path
      d="M109.332 80.1726C109.41 80.2478 109.504 80.3047 109.606 80.3391C109.709 80.3735 109.817 80.3846 109.925 80.3716C110.193 80.3296 110.458 80.2629 110.715 80.1726L110.517 79.7744L109.332 80.1726Z"
      fill="black"
    />
    <path
      d="M105.975 80.1725L106.173 80.5706C106.498 80.4848 106.827 80.4183 107.16 80.3715H107.358C107.358 80.4243 107.378 80.475 107.415 80.5123C107.452 80.5496 107.503 80.5706 107.555 80.5706H108.147C108.147 80.5178 108.127 80.4672 108.09 80.4298C108.053 80.3925 108.002 80.3715 107.95 80.3715C107.95 80.1725 107.555 79.9734 107.16 79.9734C106.76 80.0054 106.364 80.072 105.975 80.1725Z"
      fill="black"
    />
    <path
      d="M109.135 79.9734L107.95 80.3716L107.555 79.7744L107.95 79.5753L108.345 79.9734H108.542L108.345 79.5753L108.74 79.3762L109.135 79.9734Z"
      fill="black"
    />
    <path d="M109.332 79.1772L109.727 79.7745L109.135 79.9735L108.74 79.3763L109.332 79.1772Z" fill="black" />
    <path
      d="M125.525 12.8865C126.371 13.0629 127.175 13.4008 127.895 13.8818C127.895 13.8818 129.475 14.8772 127.105 16.4698C123.388 18.96 118.853 19.8886 114.467 19.0577L108.147 17.266"
      fill="#28211E"
    />
    <path
      d="M113.744 17.8596C120.496 17.5029 125.854 14.9886 125.712 12.2437C125.569 9.4989 119.979 7.56297 113.227 7.91972C106.474 8.27647 101.116 10.7908 101.258 13.5356C101.401 16.2805 106.991 18.2164 113.744 17.8596Z"
      fill="#3A3A3A"
    />
    <path d="M125.723 9.50244V12.4885L101.236 13.4839V10.8959L125.723 9.50244Z" fill="#3A3A3A" />
    <path
      d="M113.737 15.0764C120.49 14.7197 125.848 12.2054 125.705 9.46053C125.563 6.71569 119.973 4.77977 113.22 5.13652C106.468 5.49327 101.109 8.0076 101.252 10.7524C101.395 13.4973 106.984 15.4332 113.737 15.0764Z"
      fill="#28211E"
    />
    <path
      d="M126.513 4.52556C127.303 6.51627 122.168 9.50234 115.257 10.8958C108.345 12.2893 102.026 12.0903 101.236 10.0996C100.446 8.10884 105.778 5.12277 112.492 3.72927C119.206 2.33577 125.723 2.53484 126.513 4.52556Z"
      fill="#28211E"
    />
    <path
      d="M101.236 9.70129V11.0948L125.723 9.50222L126.513 5.12265L123.353 3.92822L101.236 9.70129Z"
      fill="#28211E"
    />
    <path
      d="M121.346 11.229C122.186 10.2179 122.19 8.82572 121.355 8.11946C120.519 7.41319 119.16 7.66031 118.319 8.67142C117.478 9.68253 117.474 11.0747 118.31 11.781C119.146 12.4873 120.505 12.2401 121.346 11.229Z"
      fill="#3A3A3A"
    />
    <defs>
      <linearGradient
        id="customs_paint0_linear"
        x1="87.2744"
        y1="162.568"
        x2="93.3948"
        y2="150.644"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.51" stopColor="#181816" stopOpacity="0.36" />
        <stop offset="0.82" stopColor="#080807" stopOpacity="0.82" />
        <stop offset="0.93" />
      </linearGradient>
      <linearGradient
        id="customs_paint1_linear"
        x1="1342.5"
        y1="8808.01"
        x2="1347.85"
        y2="8780.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.51" stopColor="#181816" stopOpacity="0.36" />
        <stop offset="0.82" stopColor="#080807" stopOpacity="0.82" />
        <stop offset="0.93" />
      </linearGradient>
      <linearGradient
        id="customs_paint2_linear"
        x1="1103.24"
        y1="12371.9"
        x2="1118.36"
        y2="12298.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.51" stopColor="#181816" stopOpacity="0.36" />
        <stop offset="0.82" stopColor="#080807" stopOpacity="0.82" />
        <stop offset="0.93" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
